export type CTAButtonLike = {
    translationKey: string;
    isDisabled: boolean;
    shouldRender: boolean;
};

/*
    Products enrolled in the "Display until date" feature (c_displayUntilDate set in PIM) get
    their purchase CTA decided from real stock, not from the product's own classification,
    which can say e.g. "comingsoon" even when the product is actually sold out with no known
    restock date. A product that isn't enrolled keeps its normal stock-driven CTA unchanged.
*/
export const getSoldOutCTAOverride = ({
    isEnrolled,
    hasOnlineStock,
    hasStoreStock,
    realPrimary,
    realSecondary,
}: {
    isEnrolled: boolean;
    hasOnlineStock: boolean;
    hasStoreStock: boolean;
    realPrimary?: CTAButtonLike;
    realSecondary?: CTAButtonLike;
}): { primary?: CTAButtonLike; secondary?: CTAButtonLike } => {
    if (!isEnrolled || hasOnlineStock) {
        return { primary: realPrimary, secondary: realSecondary };
    }

    if (hasStoreStock) {
        return {
            primary: {
                translationKey: 'outofstockpermanentlyonline',
                isDisabled: true,
                shouldRender: true,
            },
            secondary: { translationKey: 'findinstore', isDisabled: false, shouldRender: true },
        };
    }

    return {
        primary: { translationKey: 'outofstockpermanently', isDisabled: true, shouldRender: false },
        secondary: { translationKey: '', isDisabled: true, shouldRender: false },
    };
};
